<div class="groupHeader1">
  <ng-container *ngIf="favouriteId == 0">
      <div class="groupHeader1-title">{{'Search Results'| translate | async}}</div>
  </ng-container>

</div>

<div style="display: flex; flex-direction: row;">
    <section class="example-section">
      <mat-checkbox class="example-margin" [(ngModel)]="noOfCracks" (change)="changeCheckbox('noOfCracks')">{{'# of Cracks'| translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin" [(ngModel)]="totalCrackLength" (change)="changeCheckbox('totalCrackLength')">{{'Total Crack Length' | translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin" [(ngModel)]="AvgCrack" (change)="changeCheckbox('AvgCrack')">{{'Average Crack Length' | translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin" [(ngModel)]="fixed" (change)="changeCheckbox('fixed')">{{'Fixed' | translate | async}}</mat-checkbox>
     </section>  
</div>
  

<div class="table-container mat-elevation-z8">
  <div style="margin-left: 39%;" *ngIf="EquipmentdetailsList==null && implementTypeListForTable_.length==0">
      <mat-spinner> </mat-spinner>
  </div>


  <div *ngIf="EquipmentdetailsList!=null && implementTypeListForTable_.length>0">


      <table id="table_detail" cellpadding=10 class="table table--full-width table--striped">
        <thead>
       
            <th style="text-align: left;padding: 20px 25px; white-space: nowrap;">
              <!-- Asset<i class="material-icons button__icon">arrow_forward</i>
              Equipment<i class="material-icons button__icon">arrow_downward</i> -->
              </th>   
            <ng-container *ngFor="let equ of EquipmentdetailsList.Details">               
              <th style="text-align: center;padding: 20px 25px; white-space: nowrap;" >{{equ.serialNo}} </th>                     
            </ng-container>        
         
        </thead>
        <tbody>
    <ng-container *ngFor="let im of implementTypeListForTable_">
        <tr (click)="openImplemetCrackViewDialog(im)" style="cursor: pointer;">
            <td style="text-align: left;padding: 20px 25px; white-space: nowrap;"> {{im.Name}}</td>
        
        <ng-container *ngFor="let eq of EquipmentdetailsList.Details">
         <ng-container *ngIf="showValue2(eq.EquipmentId,im)">
        <ng-container *ngFor="let e of im.Equipment">
               
                    <!-- <ng-container *ngFor="let imp of implementTypeListForTable_.Equipment"> -->
                      <!-- <ng-container *ngIf="showValue(e,eq.EquipmentId) && e == eq.EquipmentId"> -->
                        <ng-container *ngIf="e.euipmentID== eq.EquipmentId">
                        <td *ngIf="!IsnoOfCracks && !IstotalCrackLength && !IsAvgCrack && !Isfixed">0</td>
                        <td *ngIf="IstotalCrackLength && IsnoOfCracks && IsAvgCrack && Isfixed">{{e.numberofcracks}}/ {{e.totalcrackLength}}/ {{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}/ {{e.fixedCrack}}</td>

                        <td *ngIf="IsnoOfCracks && !IstotalCrackLength && !IsAvgCrack && !Isfixed">{{e.numberofcracks}}</td>
                        <td *ngIf="IstotalCrackLength && !IsnoOfCracks && !IsAvgCrack && !Isfixed">{{e.totalcrackLength}}</td>
                        <td *ngIf="IsAvgCrack && !IstotalCrackLength && !IsnoOfCracks && !Isfixed">{{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}</td> 
                        <td *ngIf="Isfixed && !IsnoOfCracks && !IstotalCrackLength && !IsAvgCrack">{{e.fixedCrack}}</td>

                        <td *ngIf="IsnoOfCracks && IstotalCrackLength && !IsAvgCrack && !Isfixed">{{e.numberofcracks}}/ {{e.totalcrackLength}}</td>
                        <td *ngIf="IsnoOfCracks && !IstotalCrackLength && IsAvgCrack && !Isfixed">{{e.numberofcracks}}/ {{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}</td>
                        <td *ngIf="IsnoOfCracks && !IstotalCrackLength && !IsAvgCrack && Isfixed">{{e.numberofcracks}}/ {{e.fixedCrack}}</td>
                        <td *ngIf="!IsnoOfCracks && IstotalCrackLength && IsAvgCrack && !Isfixed">{{e.totalcrackLength}}/ {{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}</td>
                        <td *ngIf="!IsnoOfCracks && IstotalCrackLength && !IsAvgCrack && Isfixed">{{e.totalcrackLength}}/ {{e.fixedCrack}}</td>
                        <td *ngIf="!IsnoOfCracks && !IstotalCrackLength && IsAvgCrack && Isfixed">{{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}/ {{e.fixedCrack}}</td>

                        <td *ngIf="IsnoOfCracks && IstotalCrackLength && IsAvgCrack && !Isfixed">{{e.numberofcracks}}/ {{e.totalcrackLength}}/ {{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}</td>
                        <td *ngIf="!IsnoOfCracks && IstotalCrackLength && IsAvgCrack && Isfixed">{{e.totalcrackLength}}/{{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}/ {{e.fixedCrack}}</td>
                        <td *ngIf="IsnoOfCracks && !IstotalCrackLength && IsAvgCrack && Isfixed">{{e.numberofcracks}}/ {{e.AvgCrackLength>0? e.AvgCrackLength.toFixed(1):0}}/ {{e.fixedCrack}}</td>
                        <td *ngIf="IsnoOfCracks && IstotalCrackLength && !IsAvgCrack && Isfixed">{{e.numberofcracks}}/ {{e.totalcrackLength}}/ {{e.fixedCrack}}</td>
                     </ng-container>
              <!-- </ng-container>                      -->
         </ng-container>                   
       
        </ng-container>
        <td *ngIf="!im.isPrint" ></td>
    </ng-container>
    </tr>
    </ng-container>
      </tbody>
      <!-- <tbody>
        <ng-container *ngFor="let eq of EquipmentdetailsList.Details">
          <ng-container *ngFor="let imp of ImplementypesList">
            <tr *ngIf="eq.EquipmentId == imp.EquipmentId">
              <td > {{imp.CrackCount}}/ {{imp.ObsCount}}</td>
             

            </tr>
          </ng-container>
        </ng-container>
      </tbody> -->
              <!-- <tr> -->
                  <!-- <td colspan=7>
                      <table class="table table--full-width table--striped" *ngIf="eq.IsExapand"
                          style="margin-left: 2%;">
                          <thead>
                              <tr>
                                  <th  style="padding: 0px 24px;width: 32%;">System </th>
                                  <th style="padding: 0px 24px;width: 10%;">System Condition</th>
                                  <th style="padding: 0px 24px;width: 10%;;text-align: center;">No of Cracks </th>
                                  <th></th>

                              </tr>
                          </thead>
                          <tbody>
                              <ng-container *ngFor="let imp of ImplementypesList">
                                  <tr *ngIf="eq.EquipmentId == imp.EquipmentId">
                                      <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{imp.Name}}</td>
                                      <td><span class="Eval-{{ imp.WorstWorn | wornPercentageToEval}}"
                                              style="margin-right: 7px;padding: 7px 21px;">
                                              <div>{{imp.WorstWorn?.toFixed(1)}}%</div>
                                          </span></td>
                                      <td><span class="Eval-{{ imp.WorstWorn | wornPercentageToEval}}"
                                              style="margin-right: 7px;padding: 7px 21px;">
                                              <div>{{imp.CrackCount}}/ {{imp.ObsCount}}</div>
                                          </span></td>
                                      <td *ngIf="imp.HasComponents">
                                          <i style="cursor: pointer;" *ngIf="imp.IsExapand"
                                              class="material-icons ttmodal__close-button"
                                              (click)="ChangeExpandImp(imp)" matTooltip="Show Less">expand_less</i>
                                          <i style="cursor: pointer;" *ngIf="!imp.IsExapand"
                                              class="material-icons ttmodal__close-button"
                                              (click)="ChangeExpandImp(imp)" matTooltip="Show More">expand_more</i>
                                      </td>

                                  </tr>

                                  <tr *ngIf="imp.HasComponents && eq.EquipmentId == imp.EquipmentId">
                                      <td colspan=4>
                                          <table class="table table--full-width table--striped" *ngIf="imp.IsExpand"
                                              style="margin-left: 2%;">
                                              <thead>
                                                  <tr>
                                                      <th style="padding: 0px 24px">Component </th>
                                                      <th style="padding: 0px 24px;width: 10%;text-align: center;">Worn %</th>
                                                      <th style="padding: 0px 24px;width: 10%;text-align: center;">Average </th>
                                                      <th style="padding: 0px 24px;text-align: center;">CMU </th>
                                                      <th style="padding: 0px 24px;text-align: center;">Residual </th>
                                                      <th style="padding: 0px 24px;text-align: center;">Projected </th>


                                                      <th></th>

                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  <ng-container *ngFor="let comp of imp.Components">
                                                      <tr style="cursor: pointer;"
                                                          (click)="OpenComponentHistroy(comp.ComponentId,imp.Name)">
                                                          <td>{{comp.CompTypeName}} - {{comp.CompName}}</td>
                                                          <td><span class="Eval-{{ comp.Worn | wornPercentageToEval}}"
                                                                  style="margin-right: 7px;padding: 7px 21px;">
                                                                  <div>{{comp.Worn?.toFixed(1)}}%</div>
                                                              </span></td>
                                                          <td *ngIf="comp.Avg==-999"><span class="Eval-U"
                                                                  style="margin-right: 7px;padding: 7px 21px;">
                                                                  <div>N/A</div>
                                                              </span></td>
                                                          <td *ngIf="comp.Avg!=-999"><span
                                                                  class="Eval-{{ comp.Worn | wornPercentageToEval}}"
                                                                  style="margin-right: 7px;padding: 7px 21px;">
                                                                  <div>{{comp.Avg.toFixed(2)}}</div>
                                                              </span>
                                                          </td>

                                                          <td style="text-align: center;">{{comp.CMU}}</td>
                                                          <td  style="text-align: center;">{{comp.Residual}}</td>
                                                          <td  style="text-align: center;">{{getProjected(comp.CMU,comp.Residual)}}</td>
                                                      </tr>
                                                  </ng-container>
                                              </tbody>

                                          </table>
                                      </td>
                                  </tr>
                              </ng-container>
                          </tbody>

                      </table>
                  </td> -->

              <!-- </tr> -->
       




      </table>

  </div>

  
</div>